import React from "react";

// @material-ui/icons
import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
// core components
import { useState } from "react";
import { useQuery } from "react-query";
import BackupIcon from "@mui/icons-material/SettingsBackupRestore";
import PrettyBytes from 'react-pretty-bytes';
import { Box } from '@mui/material';
import axios from "axios";
import { Alert } from '@mui/material';
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";


export default function RawBackupTable(props) {
  let url = "/api/v1/backup/backups";
  const [token, setToken] = useToken();
  const [open, setOpen] = React.useState(true);
  const [backupResponse, setBackupResponse] = React.useState(false);
  const [severity, setSeverity] = React.useState("success");
  const [backupMsg, setBackupMsg] = React.useState("");
  const [catchUpLoad, setCatchUpLoad] = React.useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [anchorElPop, setAnchorElPop] = React.useState(null);
  const openRestorePop = Boolean(anchorElPop);
  const restorePopId = openRestorePop ? "restore-popover" : undefined;
  const [backupFile, setBackupFile] = useState("");
  const [label, setLabel] = useState("Update a Backup");

  useAxiosAuth(token);

  const BackupName = () => <BackupIcon fontSize="medium" />;
 
  const columns = [
    { Header: "", accessor: "backup", width: "1px" },
    {
      Header: "Name",
      accessor: "name",
      align: "left",
      isSorted: true,
    },
    { Header: "Last Sync", accessor: "lastsync", align: "left" },
    { Header: "Size", accessor: "size", align: "center" },

  ];

  const { isLoading, error, data } = useQuery(
    "rawbackup",
    () =>
      axios
        .get(url + "/" +  props.backupId + "/raw", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => (res.hasOwnProperty('data') && res.data.hasOwnProperty('data'))? res.data.data : null
      ),
    {
      refetchInterval: 10000,
    }
  );

  const backupData = (data) => {
    let tableData = {
      columns: columns,
      rows: [],
    };
    
    if (data && data.hasOwnProperty("items") && data.items.length > 0) {
        tableData.rows = data.items.map((item) => {
          return {
            name: item.file_info.name,
            lastsync: item.file_info.last_modified
              ? item.file_info.last_modified
              : "",
            size: (item.file_info.size) ? <PrettyBytes bytes={item.file_info.size}  /> : "",
          };
        });
      
    }

    return tableData;
  };

 
  return (
    <React.Fragment>
      {isError ? (
        <Box sx={{ paddingLeft: "10px" }}>
          <Alert severity="error">{message ? message : "error"}</Alert>
        </Box>
      ) : null}
      {error ? (
        <Box>
          <Alert severity="error">Error loading backup data</Alert>
        </Box>
      ) : null}

      {isLoading && (
        <CircularProgress
          size={24}
          style={{ marginLeft: "45%", position: "relative", top: 4 }}
        />
      )}

      <DataTable
        tableTitle="Raw Backups"
        table={backupData(data)}
        canSearch={true}
        showTotalEntries={true}
        isSorted={true}
        initialSortField="last_modified"
        initialSortDesc={true}
        noEndBorder
        entriesPerPage={true}
      />
    </React.Fragment>
  );
}
